import React from "react";
import { Truck, RotateCcw, MapPin, Gift } from "lucide-react";

export default function Livraison() {
  return (
    <div data-testid="livraison-page">
      <div className="bg-noir text-center py-16 px-6 grain relative">
        <h1 className="font-display text-4xl md:text-6xl text-white relative">Livraison & Retours</h1>
        <p className="font-serif-el italic text-dore text-lg mt-2 relative">Rapide et sans souci en Guadeloupe</p>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-14 grid md:grid-cols-2 gap-10">
        <div className="bg-white border border-dore/20 p-8">
          <Truck size={30} className="text-dore mb-3" />
          <h2 className="font-display text-2xl text-encre mb-4">Livraison</h2>
          <ul className="space-y-3 text-sm text-ardoise">
            <li><b className="text-encre">Délais :</b> 2 à 5 jours ouvrés pour les articles en stock.</li>
            <li><b className="text-encre">Zones :</b> toute la Guadeloupe, y compris Marie-Galante, Les Saintes et La Désirade.</li>
            <li><b className="text-encre">Tarif :</b> frais calculés selon le poids de votre commande.</li>
            <li className="flex items-center gap-2 text-dore"><Gift size={16} /> Dès 13€ (0-300g), 16€ (300-600g), 20€ (600g-1kg), 25€ (+1kg).</li>
            <li><b className="text-encre">Suivi :</b> vous êtes tenue informée par WhatsApp jusqu'à réception.</li>
          </ul>
        </div>
        <div className="bg-white border border-dore/20 p-8">
          <RotateCcw size={30} className="text-dore mb-3" />
          <h2 className="font-display text-2xl text-encre mb-4">Retours</h2>
          <ul className="space-y-3 text-sm text-ardoise">
            <li><b className="text-encre">Délai :</b> retour possible sous 7 jours après réception.</li>
            <li><b className="text-encre">Conditions :</b> article non porté, dans son état et emballage d'origine.</li>
            <li><b className="text-encre">Non retournables :</b> lingerie et maillots de bain (raisons d'hygiène).</li>
            <li><b className="text-encre">Échange ou avoir :</b> selon disponibilité du stock.</li>
          </ul>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 pb-16">
        <div className="bg-rose/30 p-8 flex items-start gap-4">
          <MapPin size={26} className="text-dore shrink-0 mt-1" />
          <p className="text-sm text-ardoise">Une question sur votre livraison ou un retour ? Contactez-nous sur WhatsApp, nous vous répondons rapidement et vous accompagnons à chaque étape.</p>
        </div>
      </div>
    </div>
  );
}
